import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import { connect } from "react-redux";
import { navigate } from "@reach/router";
import Drawer from "@material-ui/core/Drawer";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import { ArrowBack } from "@material-ui/icons";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
// import MailIcon from "@material-ui/icons/Mail";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core/styles";

import Screen from "./components/Screen";
import { getJwtToken } from "../../state/selectors/user";
import SurveyForm from "./components/SurveyForm";
// import TranslatorForm from "./components/TranslatorForm";
import Loader from "./Loader";
import ImportFormNew from "./components/ImportFormNew";
// import DownloadView from "./DownloadView";

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: "flex"
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  appBar: {
    marginLeft: drawerWidth,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`
    }
  },
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  toolbar: theme.mixins.toolbar,
  button: {
    marginLeft: theme.spacing.unit
  },
  drawerPaper: {
    width: drawerWidth
  },
  content: {
    paddingLeft: drawerWidth,
    flexGrow: 1,
    padding: theme.spacing.unit * 3
  },
  backButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
});

const EditView = ({ classes, slug, jwtToken }) => {
  // eslint-disable-next-line no-unused-vars
  const [loader, setLoader] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [errorMessage, setErrorMessage] = useState("");
  const [viewContext, setViewContext] = useState("General");
  const [survey, setSurvey] = useState({
    _id: "",
    name: "",
    startDate: "",
    endDate: "",
    theme: "",
    status: "",
    type: "",
    resources: ""
  });
  const updateStatusPayload = { status: "published" };
  const [message, setMessage] = useState("");
  const stateRenderer = [
    "General",
    "Importer" /*, "Translator", "Downloader"*/
  ];

  useEffect(() => {
    if (slug !== undefined) {
      getSurvey(slug);
    }
  }, [slug]);

  const renderDifferentViewContext = () => {
    switch (viewContext) {
      case "General":
        return <SurveyForm survey={survey} jwtToken={jwtToken} />;
      case "Importer":
        return <ImportFormNew survey={survey} jwtToken={jwtToken} />;
      // case "Translator":
      //   return <TranslatorForm survey={survey} jwtToken={jwtToken} />;
      // case "Downloader":
      //   return <DownloadView survey={survey} jwtToken={jwtToken} />;
      default:
        return "";
    }
  };
  const getSurvey = async surveySlug => {
    setLoader(true);
    setMessage("fetching survey");
    try {
      const {
        _id,
        name,
        startDate,
        endDate,
        status,
        theme,
        type,
        resources
      } = await API.get("surveys", `/surveys/name/${surveySlug}`);
      setLoader(false);
      setSurvey({
        _id,
        name,
        startDate,
        endDate,
        theme,
        status,
        type,
        resources
      });
    } catch (error) {
      setLoader(false);
      setErrorMessage(error.message);
    }
  };

  const publishSurvey = async () => {
    setLoader(true);
    setMessage("publishing survey");
    try {
      //add extra endpoint on the backend
      const response = await API.put(
        "surveys",
        `/surveys/${survey._id}/status`,
        {
          body: updateStatusPayload,
          headers: { Authorization: `Bearer ${jwtToken}` }
        }
      );

      setSurvey({ ...survey, status: response.status });
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setErrorMessage(error.message);
    }
  };

  return (
    <Screen>
      <Loader loader={loader} message={message} />
      <Drawer
        variant="permanent"
        anchor="left"
        open
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <div className={classes.toolbar} />
        <Divider />
        <Button
          className={classes.backButton}
          onClick={() => navigate("/admin")}
        >
          <ArrowBack />
        </Button>
        <List>
          {stateRenderer.map((name, index) => (
            <ListItem button key={index} onClick={() => setViewContext(name)}>
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary={name} />
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Grid container spacing={16} justify="center" className={classes.content}>
        <Grid item xs={12}>
          <Toolbar>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={publishSurvey}
              disabled={survey.status === "published"}
            >
              Publish
            </Button>
          </Toolbar>
        </Grid>
        <Grid item>{renderDifferentViewContext()}</Grid>
      </Grid>
    </Screen>
  );
};

const mapStateToProps = state => ({
  jwtToken: getJwtToken(state)
});

export default connect(mapStateToProps)(withStyles(styles)(EditView));
